import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Brain, ArrowRight, Newspaper, ShoppingCart } from '@phosphor-icons/react';

const Dashboard = () => {
  const { user, isPremium, isAnnual } = useAuth();

  const quickActions = [
    { href: '/ai-coach', icon: Brain, label: 'AI Coach', color: '#007AFF' },
    { href: '/store', icon: ShoppingCart, label: 'Store', color: '#34C759' },
    { href: '/crypto-news', icon: Newspaper, label: 'News', color: '#FF9500' },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="font-heading font-black text-3xl sm:text-4xl uppercase text-white mb-2" data-testid="dashboard-title">
            Welcome back, {user?.name?.split(' ')[0]}
          </h1>
          <p className="text-[#8892B0]">
            Your dashboard
          </p>
        </div>

        {/* Subscription Banner */}
        {!isPremium && (
          <div className="mb-8 bg-gradient-to-r from-[#007AFF]/20 to-[#34C759]/20 border border-[#007AFF]/30 p-6" data-testid="upgrade-banner">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <h3 className="font-heading font-bold text-xl uppercase text-white mb-1">
                  Upgrade to Premium
                </h3>
                <p className="text-[#8892B0]">
                  Unlock unlimited AI access, advanced features, and more.
                </p>
              </div>
              <Link
                to="/pricing"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#007AFF] text-white font-bold uppercase tracking-widest hover:bg-[#005bb5] transition-colors"
              >
                View Plans <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        )}

        {/* Quick Actions */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          {quickActions.map((action) => (
            <Link
              key={action.href}
              to={action.href}
              className="bg-[#131313] border border-white/5 p-6 hover:bg-[#1A1A1A] hover:border-white/20 transition-colors text-center"
              data-testid={`quick-action-${action.label.toLowerCase().replace(' ', '-')}`}
            >
              <action.icon size={32} weight="duotone" style={{ color: action.color }} className="mx-auto mb-3" />
              <span className="text-white font-bold uppercase tracking-wider text-sm">{action.label}</span>
            </Link>
          ))}
        </div>

        {/* Telegram Coach Banner for Premium Users */}
        {isPremium && (
          <div className={`mt-8 ${isAnnual ? 'tracing-beam' : ''} p-[2px]`} data-testid="human-coach-banner">
            <div className="bg-[#131313] p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <h3 className="font-heading font-bold text-xl uppercase text-white mb-1">
                  {user.subscription_tier === 'lifetime' ? 'Human Coaching (Unlimited)' :
                   user.subscription_tier === 'annual_vip' ? 'Human Coaching (3 Sessions/Month)' :
                   (user.subscription_tier === 'annual_elite') ? 'Human Coaching (2 Sessions/Month)' :
                   (user.subscription_tier === 'annual_pro') ? 'Human Coaching (1 Session/Month)' :
                   user.subscription_tier === 'annual' ? 'Human Trade Journals (Unlimited)' :
                   'Human Trade Journal (1/Month)'}
                </h3>
                <p className="text-[#8892B0]">
                  Connect with your coach via Telegram for personalized trading support.
                </p>
              </div>
              <a
                href={process.env.REACT_APP_TELEGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center gap-2 px-6 py-3 font-bold uppercase tracking-widest transition-colors ${
                  isAnnual 
                    ? 'bg-[#34C759] text-black hover:bg-[#2db550]'
                    : 'bg-[#007AFF] text-white hover:bg-[#005bb5]'
                }`}
                data-testid="contact-coach-btn"
              >
                Contact Coach
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
